import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import request from '../utils/request';

const BADGE_INTERVAL_MS = 3000;

const PendingBadgeContext = createContext({
  pendingCount: 0,
  refreshPendingCount: async () => {}
});

export function PendingBadgeProvider({ children }) {
  const location = useLocation();
  const [pendingCount, setPendingCount] = useState(0);

  const isH5App = !location.pathname.startsWith('/admin');

  const refreshPendingCount = useCallback(async () => {
    try {
      const res = await request({ url: '/api/matches/pending/count', method: 'GET' });
      setPendingCount(res.data?.count ?? 0);
    } catch (err) {
      console.error('获取待处理数失败:', err);
      setPendingCount(0);
    }
  }, []);

  useEffect(() => {
    if (!isH5App) return undefined;

    const tick = () => {
      if (typeof document !== 'undefined' && document.hidden) return;
      refreshPendingCount();
    };

    // 进入 H5、切换路由、从后台返回前台时由本 effect / visibility 触发立即刷新
    tick();

    const id = setInterval(tick, BADGE_INTERVAL_MS);

    const onVisibility = () => {
      if (!document.hidden) refreshPendingCount();
    };
    document.addEventListener('visibilitychange', onVisibility);

    return () => {
      clearInterval(id);
      document.removeEventListener('visibilitychange', onVisibility);
    };
  }, [isH5App, location.pathname, refreshPendingCount]);

  return (
    <PendingBadgeContext.Provider value={{ pendingCount, refreshPendingCount }}>
      {children}
    </PendingBadgeContext.Provider>
  );
}

export function usePendingBadge() {
  return useContext(PendingBadgeContext);
}
